module.exports = "<div class=\"fury-page-load-animation\"></div>\n<router-outlet></router-outlet>\n"